import { css } from 'styled-components';
import { listResetMixin } from '../listResetMixin';
import { marginMixin } from '../marginMixin';

/** @class AccordionMixin */
/** @method */
export var AccordionMixin = function AccordionMixin(props) {
  return css(["", " ", ""], listResetMixin, marginMixin(Object.assign({}, props)));
};